export const SelectChipFromArray = (UiValue, SelectableDataArray) => {
  const Result = UiValue.reduce((accumulator, currentValue) => {
    const matchingObject = SelectableDataArray.find(
      (item) => item.ItemValue === currentValue
    );
    if (matchingObject) {
      accumulator.push(matchingObject.ItemContent);
    }
    return accumulator;
  }, []);
  return Result;
};
